import React, { useEffect } from 'react'

import { EXTENSION_URL } from '../Constants/URLEnums'

function Extension(props){
    useEffect(() => {
        window.location.href = EXTENSION_URL.DOWNLOAD_URL;
    }, [])

    return (
        <div>
            <p style={{ 'margin': 0, 'padding': 0, 'font-size': '1rem' }}>Redirecting to site to download QuickFiller extension...</p>
        </div>
    )
}

export default Extension